import Tooltip from './tooltip'

class Input extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      priorityCountries: [],
      countries: []
    }
  }

  componentDidMount() {
    if (this.props.type == 'countries') {
      // Fetch countries
      fetch(`${window.appData.api_path}/countries`)
        .then((response) => response.json())
        .then((data) => {
          this.setState({ priorityCountries: data.priority_countries, countries: data.countries })
          // Set default to the first priority country
          this.props.onChange({
            target: {
              name: this.props.name,
              value: data.priority_countries[0]
            }
          })
        })
    }
  }

  render() {
    let { className, object, ...moreProps } = this.props

    let label
    let labelName
    if (this.props.label) {
      if (this.props.label != 'false') {
        labelName = this.props.label
      }
    } else {
      labelName = I18n.t(`activerecord.attributes.${this.props.object.type}.${this.props.name}`, {
        defaultValue: I18n.t(`attributes.${this.props.name}`)
      })
    }

    let tooltip

    if (this.props.tooltip) {
      tooltip = (
        <Tooltip content={this.props.tooltip}>
          <i className="fa fa-question-circle ml-8"></i>
        </Tooltip>
      )
    }

    if (labelName) {
      label = (
        <label className="form-check-label" htmlFor={this.props.name}>
          {labelName}
          {tooltip}
        </label>
      )
    }

    let input
    if (this.props.type == 'checkbox') {
      input = (
        <div className="form-group">
          <div className="checkbox">
            <label className="boolean" htmlFor={this.props.name}>
              <input
                className="boolean"
                checked={this.props.object[this.props.name]}
                id={this.props.name}
                {...moreProps}
              />
              {labelName}
              {tooltip}
            </label>
          </div>
        </div>
      )
    } else if (this.props.type == 'textarea') {
      input = (
        <React.Fragment>
          {label}
          <textarea
            className="form-control"
            id={this.props.name}
            value={this.props.object[this.props.name]}
            {...moreProps}
          />
        </React.Fragment>
      )
    } else if (this.props.type == 'select') {
      input = (
        <div className="form-group">
          {label}
          <div className="select-wrapper">
            <select
              className="form-control"
              id={this.props.name}
              value={this.props.object[this.props.name]}
              {...moreProps}
            >
              {this.props.options.map((i) => (
                <option key={i[1]} value={i[1]}>
                  {i[0]}
                </option>
              ))}
            </select>
          </div>
        </div>
      )
    } else if (this.props.type == 'countries') {
      input = (
        <div className="form-group">
          {label}
          <div className="select-wrapper">
            <select
              className="form-control"
              id={this.props.name}
              value={this.props.object[this.props.name]}
              {...moreProps}
            >
              <option value=""></option>
              {this.state.priorityCountries.map((i) => (
                <option key={i} value={i}>
                  {this.state.countries.find((ii) => ii.code == i)?.name || i}
                </option>
              ))}
              <option disabled>---------------</option>
              {this.state.countries
                .filter((i) => !this.state.priorityCountries.includes(i.code))
                .map((i) => (
                  <option key={i.code} value={i.code}>
                    {i.name}
                  </option>
                ))}
            </select>
          </div>
        </div>
      )
    } else if (this.props.append) {
      input = (
        <React.Fragment>
          {label}
          <div className="input-group">
            <input
              className="form-control"
              id={this.props.name}
              value={this.props.object[this.props.name]}
              {...moreProps}
            />
            <div className="input-group-append">
              <div className="input-group-text">{this.props.append}</div>
            </div>
          </div>
        </React.Fragment>
      )
    } else {
      input = (
        <React.Fragment>
          {label}
          <input
            className={classNames('form-control', this.props.className, {
              'is-invalid':
                this.props.object.errors &&
                this.props.object.errors[this.props.name] &&
                this.props.object.errors[this.props.name].length
            })}
            id={this.props.name}
            value={this.props.object[this.props.name]}
            {...moreProps}
          />
        </React.Fragment>
      )
    }

    let hasError =
      this.props.object.errors &&
      this.props.object.errors[this.props.name] &&
      this.props.object.errors[this.props.name].length

    return (
      <div className={classNames('form-group', this.props.className, { 'has-error': hasError })}>
        {input}

        {this.props.hint ? <span className="help-block">{this.props.hint}</span> : null}

        {hasError ? (
          <span className="help-block">{hasError ? this.props.object.errors[this.props.name][0] : null}</span>
        ) : null}
      </div>
    )
  }
}

export default Input
